import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Te levantás con la panza plana y a media mañana ya parecés de 5 meses.', 'Comés “sano” —manzana, ajo, yogur— y te hinchás igual o peor.', 'Los gases y el dolor te obligan a aflojarte el pantalón en la oficina.', 'Los estudios “dan bien”, pero vos sabés que algo no está funcionando.', 'Alternás entre estreñimiento y diarrea sin lógica aparente.', 'Probaste probióticos, tés y dietas sueltas: nada te duró más de una semana.', 'Llegás a la noche agotada, hinchada y sin saber qué comer mañana.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-81" data-mp="1o1oe7pfupqqi">
      <div className="mx-auto max-w-4xl" data-id="element-82" data-mp="1szpszy68v3w6">
        <header className="text-center" data-id="element-83" data-mp="1t0hrbgr87fq5">
          <h2 className="font-display text-3xl font-bold sm:text-5xl" data-id="element-84" data-mp="3idbi01gq11j1">
            ¿Cuánto tiempo más vas a comer con miedo a hincharte?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-85" data-mp="3nalbptb57zco">
            Sos una persona que investiga, pregunta y no se rinde. Probaste
            eliminar alimentos, sumar suplementos y aguantar. Pero hasta ahora
            nadie te dio el orden correcto para hacerlo.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-86" data-mp="27s79z5is2fay">
            No es falta de voluntad. Es que te faltaba el sistema correcto.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-87" data-mp="1g2u9hkf961k6">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-88" data-mp="1b3hq59nlbcmc" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-89" data-mp="1t43n74qn2ixv" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-90" data-mp="1y6chc4f8zr1k">
                {point}
              </p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-91" data-mp="273mrtnk8rc5f">
          ¿Y si pudieras saber exactamente qué comer cada día para que la panza
          deje de inflamarse?
        </p>
      </div>
    </section>;
}